/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_Pagetitle1Inputs */

const ja_calendar_meta_pagetitle1 = /** @type {(inputs: Calendar_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

const en_calendar_meta_pagetitle1 = /** @type {(inputs: Calendar_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Calendar_Meta_Pagetitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const calendar_meta_pagetitle1 = /** @type {((inputs?: Calendar_Meta_Pagetitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_Pagetitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_pagetitle1(inputs)
	return en_calendar_meta_pagetitle1(inputs)
});
export { calendar_meta_pagetitle1 as "calendar_meta_pageTitle" }